<template>
  <v-dialog persistent v-model="payDialog" width="780px">
    <v-card>
      <v-card-title>
          <span class="headline">
            {{ $t("LakalaAccount.Pay.title") }}
          </span>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="payDialog = false">
              fa-times
            </v-icon>
          </template>
          <span>
              {{ $t("CRUD.backToList", [$t("LakalaAccount.title")]) }}
            </span>
        </v-tooltip>
      </v-card-title>

      <v-card-text>
        <v-container>
           <ValidationObserver ref="observer">
          <v-form>
            <v-row>
              <!-- 支付账户 -->
              <v-col cols="6">
                  <span >
                    {{ $t("LakalaAccount.Pay.outExtCode") + $t("Global.colon") }}
                  </span>
                <span class="green--text">
                  {{ lakalaSellerId }}
                  </span>
                  <span class="red--text">
                  {{ $t("LakalaAccount.Pay.baseLakalaAccount") }}
                  </span>
              </v-col>
              <!-- 账户余额 -->
              <v-col cols="6">
                  <span>
                    {{ $t("LakalaAccount.Pay.totalAmount") }}{{ $t("Global.colon") }}
                  </span>
                <span class="red--text">
                   {{ $t("Global.money") }}{{ totalAmount | formatMoney }}
                  </span>
              </v-col>
              <!-- 手续费 -->
              <v-col cols="6">
                  <span>
                    {{ $t("LakalaAccount.Pay.freezeAmount") }}{{ $t("Global.colon") }}
                  </span>
                <span class="red--text">
                   {{ $t("Global.money") }}{{ freezeAmount | formatMoney }}
                  </span>
              </v-col>
              <!-- 剩余余额 -->
              <v-col cols="6">
                  <span>
                    {{ $t("LakalaAccount.Pay.availableAmount") }}{{ $t("Global.colon") }}
                  </span>
                <span class="red--text">
                   {{ $t("Global.money")
                    }}{{ availableAmount | formatMoney }}
                  </span>
              </v-col>
              <!-- 收款账户 -->
              <v-col cols="6">
                  <span >
                    {{ $t("LakalaAccount.Pay.inExtCode") + $t("Global.colon") }}
                  </span>
                <span class="green--text">
                  {{ lakalaAccount.lakala_member_no }}
                  </span>
              </v-col>
              <!-- 收款账户 -->
              <v-col cols="6">
                  <span >
                    {{ $t("LakalaAccount.Pay.companyName") + $t("Global.colon") }}
                  </span>
                <span class="green--text">
                    {{ lakalaAccount.company_name }}({{ lakalaAccount.lakala_out_member_no }})
                </span>
              </v-col>
              <!-- 付款金额-->
              <v-col cols="6">
                <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('LakalaAccount.Pay.balancePay')"
                    :rules="{
                        max_value: {
                            max: availableAmount,
                        },
                        min_value: {
                            min: 0.01,
                        },
                        required: {
                            required: true
                        }
                    }"
                >
                    <span class="d-flex">
                    {{ $t("LakalaAccount.Pay.balancePay") }}{{ $t("Global.colon") }}
                    <v-text-field
                        v-model="balancePay"
                        single-line
                        dense
                        type="number"
                        min="0"
                        :disabled="isBalancePayDisabled"
                        :prefix="$t('Global.money')"
                        :error-messages="errors"
                        @blur="balancePay = $numberFormatter.formatMoney(balancePay)"
                    ><template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                    </span>
                  </ValidationProvider>
              </v-col>
              <!-- 验证码 -->
              <v-col cols="6" v-if="isBalancePayDisabled">
                  <span class="d-flex">
                    {{ $t("LakalaAccount.Pay.VCode") }}{{ $t("Global.colon") }}
                    <v-text-field
                        v-model="VCode"
                        single-line
                        dense
                        persistent-hint
                        :hint="$t('LakalaAccount.vc_code_hint')"
                    />
                  </span>
                </v-col>
            </v-row>
          </v-form>
           </ValidationObserver>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined @click="payDialog = false">{{ $t("$vuetify.close") }}</v-btn>
        <v-btn color="accent" @click="submit()">{{ $t("CRUD.confirm") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import i18n from "@/i18n";
import Payment from "@/api/payment";
import LakalaInterface from "@/api/lakala_interface";
import ThirdAccountInfo from "@/api/third-account-info"
import { ValidationObserver, ValidationProvider } from "vee-validate";


export default {
    name: "PayDialog",

    props: {
        value: Boolean,
        item: Object
    },
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    data: () => ({
        payDialog: false,
        lakalaAccount: {},
        lakalaSellerId: "",
        specialAccountNo: "",
        totalAmount: 0,
        freezeAmount: 0,
        availableAmount: 0,
        balancePay: null,
        VCode: null,
        payCode: null,
        isBalancePayDisabled: false,
    }),
    mounted() {

    },
    methods: {
        getSettings() {
            //获取汇付总账户ID
            Payment.fetch({
                keys: [
                    "lakala_sellerId", // 拉卡拉总账户ID
                    "lakala_special_account_no", // 拉卡拉标识
                ],
            }).then((settingResponse) => {
                if (settingResponse.data.status.isOK()) {
                    this.lakalaSellerId = settingResponse.data.settings.lakala_sellerId;
                    this.specialAccountNo = settingResponse.data.settings.lakala_special_account_no;
                    if (this.lakalaSellerId && this.specialAccountNo) {
                        LakalaInterface.queryBalance({member_no: this.lakalaSellerId, special_account_no: this.specialAccountNo}).then((response) => {
                            if (response.data.status.isOK()) {
                                this.totalAmount = parseFloat((response.data.result.total_amount / 100)).toFixed(2)
                                this.freezeAmount = parseFloat((response.data.result.freeze_amount / 100)).toFixed(2)
                                this.availableAmount = parseFloat((response.data.result.available_amount / 100)).toFixed(2)
                            }
                        })
                    }
                }
            })
        },
        submit() {
            if (!this.isBalancePayDisabled) {
                this.$refs.observer.validate().then(
                    async function (result) {
                        if (result) {
                            let submitData = {
                                balance_pay: this.balancePay,
                                pay_type: 104, // 支付类型：拉卡拉：104
                                lkl_member_no: this.lakalaAccount.lakala_member_no
                            }
                            ThirdAccountInfo.addLklBalancePay(submitData).then((payResponse) => {
                                if (payResponse.data.status.isOK()) {
                                    this.payCode = payResponse.data.third_pay_records.pay_code
                                    if (payResponse.data.mobile_validation_flg && payResponse.data.mobile_validation_code != '') {
                                        let submitData = {
                                            pay_code: this.payCode,
                                            validation_code: payResponse.data.mobile_validation_code
                                        }
                                        LakalaInterface.balancePay(submitData).then(
                                            function (response) {
                                                if (response.data.status.isOK()) {
                                                    this.$snackbar.success(i18n.t("LakalaAccount.Pay.successMsg"));
                                                    this.payDialog = false
                                                }
                                            }.bind(this)
                                        )
                                    }else {
                                        ThirdAccountInfo.mobileValidation({third_record_code: this.payCode, type: 1}).then((response) => {
                                            if (response.data.status.isOK()) {
                                                this.$snackbar.success(i18n.t("LakalaAccount.Pay.mobileVCode"));
                                                this.isBalancePayDisabled = true
                                            }
                                        })
                                    }
                                }
                            })
                        }
                    }.bind(this)
                )
            }else if (this.VCode != '') {
                let submitData = {
                    pay_code: this.payCode,
                    validation_code: this.VCode
                }
                LakalaInterface.balancePay(submitData).then(
                    function (response) {
                        if (response.data.status.isOK()) {
                            this.$snackbar.success(i18n.t("LakalaAccount.Pay.successMsg"));
                            this.payDialog = false
                        }
                    }.bind(this)
                )
            }
        },
    },

    watch: {
        value: {
            immediate: false, //初始赋值也调用
            handler() {
                if (this.value) {
                    this.getSettings();
                } else {
                    this.lakalaAccount = {};
                    this.balancePay = null;
                    this.lakalaSellerId = "";
                    this.specialAccountNo = "";
                    this.totalAmount = 0;
                    this.freezeAmount = 0;
                    this.availableAmount = 0;
                    this.VCode = null;
                    this.payCode = null;
                    this.isBalancePayDisabled = false
                    this.$refs.observer.reset();
                }
                this.payDialog = this.value;
            },
        },
        item: {
            immediate: false, //初始赋值也调用
            handler() {
                this.lakalaAccount = this.item;
            },
        },
        payDialog: {
            handler() {
                this.$emit("input", this.payDialog);
            },
        },
    },
};
</script>